import $ from 'jquery'
import UIkit from '../../../../node_modules/uikit/dist/js/uikit-core.js'

var options = {
	'enable' : true,
	'dom' : {
		'wrapper' : 'body',
		'hide' : '.js-hide-consent'
	},
	'cookie_name' : 'cookieconsent_status',
	'policy_link' : window.location.href + '/cookie-policy',
}

var text = {
	'content' : 'We use cookies to ensure you get the best experience on our website. <a class="uk-text-underline" style="color:white;" href="'+options.policy_link+'">Learn more</a>',
	'button_text' : 'Got it!'
}

var boxClasses = 'uk-position-fixed uk-position-bottom-left uk-card uk-card-small uk-card-body uk-card-primary \
				uk-margin uk-margin-left uk-margin-right uk-width-medium';

var templates = {
	box : () => '<div class="cookie-consent '+boxClasses+'" style="z-index:999;max-width:85%;">'+templates.main()+templates.button()+'</div>',
	main: () => '<div class="cookie-consent-content">'+text.content+'</div>',
	button: () => '<button class="cookie-consent-button uk-button uk-button-secondary js-hide-consent uk-margin-small-top">'+text.button_text+'</button>'
}

var box;

function hide(){
	setCookie(options.cookie_name, 'yes', 365, '', '/', false);
	box.fadeOut(250,function(){
		box.remove()
	})
}

function getCookie(name){
	var value = '; ' + document.cookie;
	var parts = value.split('; ' + name + '=');
	return parts.length < 2
		? undefined
		: parts.pop().split(';').shift();
}

function setCookie(name, value, expiryDays, domain, path, secure) {
	var exdate = new Date();
	exdate.setDate(exdate.getDate() + (expiryDays || 365));

	var cookie = [
	name + '=' + value,
		'expires=' + exdate.toUTCString(),
		'path=' + (path || '/')
	];

	if (domain) {
		cookie.push('domain=' + domain);
	}
	if (secure) {
		cookie.push('secure');
	}
	document.cookie = cookie.join(';');
}

function createBox(){
	return $(templates.box());
}

function show(){
	box = createBox()
	$(options.dom.wrapper).prepend(box.hide())
	box.fadeIn(250)
}

function shouldShow(){
	return true
}

function init(){
	if(shouldShow()) show()
	$(options.dom.wrapper).on('click', options.dom.hide, hide)
}

if(options.enable && !getCookie(options.cookie_name)){
	init()
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/cookie_consent.js